import React from 'react';

export const Loading = () => {
    return(
            <div className='row justify-content-center'>
                <div className="col-4 m-5">
                    <span className="fa fa-cog fa-spin fa-2x" style={{ color: "black" }}>
                    </span>
                    <h6>cargando . . .</h6>
                </div>
            </div>
    );
};

export const Logging = () => {
    return(
            <div className='row justify-content-center'>
                <div className="col-6 offset-4 m-5">
                    <span className="fa fa-user fa-spin fa-2x" style={{ color: "black" }}>
                    </span>
                    <h6>verificando usuario . . .</h6>
                </div>
            </div>
    );
};

export const SavingPorts = () => {
    return(
            <div className="col">
                <i className="fa fa-cog fa-spin"></i>
                <p>guardando . . .</p>
            </div>
    );
};

export const AskingQuestion = () => {
    return(
            <div className="col">
                <i className="fa fa-lightbulb-o fa-spin"></i>
                <p>dame unos segundos . . .</p>
            </div>
    );
};

export const Searching = () => {
    return(
            <div className="col">
                <i className="fa fa-cog fa-db fa-2x"></i>
                <p>buscando datos . . .</p>
            </div>

    );
};

export const DownloadingFile = () => {
    return(
            <div className="col">
                <i className="fa fa-cog fa-spin"></i>
                <p>descargando archivo . . .</p>
            </div>
    );
};

export const LoadingFile = () => {
    return(
            <div className="col">
                <i className="fa fa-cog fa-spin"></i>
                <p>cargando archivo . . .</p>
            </div>
    );
};

export const Checking = () => {
    return(
            <div className="col">
                <i className="fa fa-lightbulb-o fa-spin"></i>
                <p>verificando . . .</p>
            </div>
    );
};

export const DownloadingPorts = () => {
    return(
            <div className="col">
                <i className="fa fa-cog fa-spin"></i>
                <p>descargando portafolios . . .</p>
            </div>
    );
};

export const CustomLoading = ({
  msg = "cargando",
  icon = "fa-cog",
  mt = "5"
}) => {
  return (
    <div
      className={`col d-flex flex-column align-items-center justify-content-center mt-${mt}`}
      style={{ textAlign: "center" }}
    >
      <i className={`fa ${icon} fa-spin`} style={{ color: "black" }}></i>
      <h6>{msg} . . .</h6>
    </div>
  );
};